module.exports = __webpack_public_path__ + "static/media/SINGLE BREASTED 6 BUTTONS.7ce22243.svg";